var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "Modal2",
        {
          attrs: {
            design: "v3",
            "class-name": "bulk-owner-modal",
            "show-footer": false,
            "show-title": false,
          },
          on: { cancel: _vm.onCancel },
        },
        [
          _c("div", { staticClass: "bulk-owner-modal-content" }, [
            _c("div", { staticClass: "modal-section" }, [
              _c("div", { staticClass: "info-banner" }, [
                _c("div", { staticClass: "banner-icon" }, [
                  _c("i", { staticClass: "material-icons" }, [_vm._v("info")]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "banner-content" }, [
                  _c("div", { staticClass: "banner-title" }, [
                    _vm._v(_vm._s(_vm.$t("auto.information"))),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "banner-text" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("auto.usersShownBelowAreIntersection")) +
                        "\n                    "
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "selection-wrapper" }, [
                _c("div", { staticClass: "section-title" }, [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("person_search"),
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("auto.ownerUserSelection"))),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "form-field",
                    staticStyle: { "margin-bottom": "24px" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                          "justify-content": "space-between",
                        },
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "field-label",
                            staticStyle: { "margin-bottom": "0" },
                          },
                          [_vm._v(_vm._s(_vm.$t("auto.removeOwnership")))]
                        ),
                        _vm._v(" "),
                        _c("a-switch", {
                          model: {
                            value: _vm.isRemoveOwner,
                            callback: function ($$v) {
                              _vm.isRemoveOwner = $$v
                            },
                            expression: "isRemoveOwner",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "field-hint" }, [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("info_outline"),
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("auto.checkToRemoveOwnershipFromContacts")
                          )
                        ),
                      ]),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "form-field",
                    style: {
                      opacity: _vm.isRemoveOwner ? 0.5 : 1,
                      pointerEvents: _vm.isRemoveOwner ? "none" : "auto",
                    },
                  },
                  [
                    _c("label", { staticClass: "field-label" }, [
                      _vm._v(_vm._s(_vm.$t("auto.userwith"))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a-select",
                      {
                        staticClass: "owner-select",
                        attrs: {
                          size: "large",
                          placeholder: _vm.$t("auto.selectOwnerUser"),
                          "filter-option": _vm.filterOption,
                          "show-search": "",
                          disabled: _vm.isRemoveOwner,
                        },
                        model: {
                          value: _vm.selectedOwner,
                          callback: function ($$v) {
                            _vm.selectedOwner = $$v
                          },
                          expression: "selectedOwner",
                        },
                      },
                      _vm._l(_vm.availableUsers, function (user) {
                        return _c(
                          "a-select-option",
                          { key: user._id, attrs: { value: user._id } },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(user.name || user.email) +
                                "\n                        "
                            ),
                          ]
                        )
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "field-hint" }, [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("lightbulb_outline"),
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("auto.canSelectSingleUserForOwnership"))
                        ),
                      ]),
                    ]),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _vm.selectedOwner && !_vm.isRemoveOwner
                ? _c("div", { staticClass: "preview-section" }, [
                    _c("div", { staticClass: "preview-header" }, [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("visibility"),
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("auto.selectedOwner"))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "owner-card" }, [
                      _c("div", { staticClass: "owner-avatar" }, [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("person"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "owner-details" }, [
                        _c("div", { staticClass: "owner-name" }, [
                          _vm._v(_vm._s(_vm.getUserName(_vm.selectedOwner))),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "owner-role" }, [
                          _vm._v(_vm._s(_vm.$t("auto.ownerUser"))),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "owner-badge" }, [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("verified"),
                        ]),
                      ]),
                    ]),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-footer" },
              [
                _c("SupsisButton", { on: { click: _vm.onCancel } }, [
                  _vm._v(_vm._s(_vm.$t("auto.cancel"))),
                ]),
                _vm._v(" "),
                _c(
                  "SupsisButton",
                  { attrs: { primary: "" }, on: { click: _vm.onConfirm } },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("person_add"),
                    ]),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("auto.assignOwner")) +
                        "\n            "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }